import { BrowserRouter } from 'react-router';
import type { ProfileAppProps } from './ProfileApp';
import { ProfileLayout } from './ProfileLayout';
import { ProfileRoutes } from './ProfileRoutes';
import { useEffect } from 'react';

export const ProfileRouter = (props: ProfileAppProps) => {
    useEffect(() => {
        document.getElementById('profile-spinner')?.remove();
    }, []);

    return (
        <BrowserRouter basename="/profile">
            <ProfileLayout
                isAdolescent={props.isAdolescent}
                hasVeterinarianCoverage={props.hasVeterinarianCoverage}
            >
                <ProfileRoutes {...props} />
            </ProfileLayout>
        </BrowserRouter>
    );
};
